import vModal from './Modal.vue';

export { vModal };


// WEBPACK FOOTER //
// ./src/baseComponents/components/Modal/index.js